import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import './ActivityOption.scss';

const ActivityOption = ({
  redirectPath = '',
  name = '',
  color = '',
  location = '',
  time = '',
  slotTimesString = '',
  isDisabled,
}) => (
  isDisabled
    ? (
      <div className="entertainment-link" to={redirectPath}>
        <div className={classnames('entertainment-container', color, color !== '' && 'active')}>
          <div className="left-container">
            <div className="name">{name}</div>
            <div className="description">
              { !!location && <div className="left">{location}</div> }
            </div>
            { !!time && <div className="event-time">{time}</div> }
          </div>
        </div>
      </div>
    )
    : (
      <Link className="entertainment-link" to={redirectPath}>
        <div className={classnames('entertainment-container', color, color !== '' && 'active')}>
          <div className="left-container">
            <div className="name">{name}</div>
            <div className="description">
              { !!location && <div className="left">{location}</div> }
            </div>
            <div className="event-time">{time || slotTimesString}</div>
          </div>
          <div className="right-container">
            <FontAwesomeIcon icon={faChevronRight} size="sm" />
          </div>
        </div>
      </Link>
    )
);

ActivityOption.propTypes = {
  redirectPath: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  color: PropTypes.string,
  time: PropTypes.string,
  slotTimesString: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default ActivityOption;
